import React from 'react';
import { DocsPageShell } from './DocsLayout';
import { getSectionsByAudience } from '../../utils/docsContent';

const teacherSections = getSectionsByAudience('teacher');

const NAV_LINKS = [
  { to: '/docs/student', label: 'Student Guide' },
  { to: '/docs/parent', label: 'Parent Guide' },
];

export const DocsTeacher = () => (
  <DocsPageShell
    title="Teacher Guide"
    subtitle="Everything you need to manage students, classes, and activities in Frankly Talking English."
    sections={teacherSections}
    navLinks={NAV_LINKS}
  />
);

export default DocsTeacher;
